/**
 * Configuración editable del sitio.
 * -----------------------------------------------------------------------
 * Este es el único archivo que hace falta tocar para cambiar datos de
 * contacto, el destino del formulario o los videos. No requiere saber JS.
 */

export const CONTACT = {
  /** Teléfono en formato internacional, sin + ni espacios. */
  whatsapp: '5491130691688',
  email: 'info.serendipiaagencia@gmail.com',
  instagram: 'https://www.instagram.com/somosserendipiaok/',
};

export const FORM = {
  /**
   * Los leads llegan por mail a la casilla de CONTACT.email usando
   * Web3Forms (https://web3forms.com): un servicio gratuito que recibe el
   * formulario y lo reenvía. No hace falta backend ni servidor propio.
   *
   * Ya está activo. Si alguna vez hay que cambiar la casilla de destino,
   * hay que pedir una Access Key nueva en https://web3forms.com con el mail
   * nuevo y pegarla acá: el destino queda atado a la clave, no se elige
   * desde el código.
   *
   * La clave NO es un secreto: viaja en el navegador y solo sirve para
   * mandar mails a la casilla que la pidió.
   */
  accessKey: '4060e5e8-a1bb-462c-9a88-b7ac0109d631',

  /** Endpoint de Web3Forms. No hace falta tocarlo. */
  endpoint: 'https://api.web3forms.com/submit',

  /** Nombre que aparece como remitente del mail. */
  fromName: 'Web Serendipia',
};

/**
 * Cómo se comportan los reels de la sección "Por qué".
 *
 *   'preview' (por defecto)
 *     El embed de Instagram se carga solo, cuando la tarjeta se acerca a la
 *     pantalla. Se ve la portada real del reel y se puede reproducir sin
 *     hacer nada. Contra: aparece la tarjeta blanca de Instagram, con su
 *     cabecera y su pie. Es de ellos, no se puede tematizar.
 *
 *   'click'
 *     Se queda la portada con los colores de la marca hasta que alguien
 *     hace click. Sección 100 % en la estética del sitio y cero carga de
 *     terceros. Contra: no se ve la miniatura real del reel de entrada.
 */
export const VIDEOS_MODE = 'preview';

/**
 * Reels de la sección "Por qué".
 *
 * - `code`   : el ID del post de Instagram (lo que va después de /p/ en la URL).
 * - `caption`: el texto que se muestra debajo del video.
 * - `poster` : opcional. Si dejás una imagen en assets/img/video/ y ponés
 *              su ruta acá, se usa como portada y el embed de Instagram se
 *              carga recién al hacer click (más rápido y con la estética de
 *              la marca). Si es null, se carga el embed con la portada
 *              propia de Instagram.
 */
export const VIDEOS = [
  {
    code: 'DZC2BVrh7H7',
    caption: 'Implementación de IA en procesos de venta y sus beneficios.',
    poster: null,
  },
  {
    code: 'DaBe5ZGBI3I',
    caption: 'Por qué tus campañas ya no funcionan.',
    poster: null,
  },
  {
    code: 'DaJIMiNhxiX',
    caption: 'Rompé el techo de tu eCommerce.',
    poster: null,
  },
  {
    code: 'DYpV_xKAD5I',
    caption: 'Nuestro sistema integral.',
    poster: null,
  },
];
